import Table from 'common/table/table';
import {
  useGetApplicationTypesQuery,
  useGetAuthorizationTypesQuery,
  useGetFoodDomainsQuery,
  useGetRiskAssessmentDeadlineCodesQuery,
  useGetValidationDeadlineCodesQuery,
} from 'services/case-type/case-type-api';
import { ReferenceItem, RiskAssessmentDeadline, ValidationDeadline } from 'services/case-type/types';

const codeDescriptionColumns = [
  { title: 'Code', dataIndex: 'code', width: 250,
    sorter: { compare: (a: ReferenceItem, b: ReferenceItem) => a.code.localeCompare(b.code) } },
  { title: 'Description', dataIndex: 'description',
    sorter: { compare: (a: ReferenceItem, b: ReferenceItem) => a.description.localeCompare(b.description) } },
];

const riskDeadlineColumns = [
  { title: 'Deadline Code', dataIndex: 'deadlineCode',
    sorter: { compare: (a: RiskAssessmentDeadline, b: RiskAssessmentDeadline) => a.deadlineCode.localeCompare(b.deadlineCode) } },
  { title: 'Value', dataIndex: 'valueCode' },
  { title: 'Time Unit', dataIndex: 'timeUnit' },
  { title: 'Type', dataIndex: 'typeCode' },
  { title: 'Status', dataIndex: 'status', width: 120 },
];

const validationDeadlineColumns = [
  { title: 'Deadline Code', dataIndex: 'deadlineCode',
    sorter: { compare: (a: ValidationDeadline, b: ValidationDeadline) => a.deadlineCode.localeCompare(b.deadlineCode) } },
  { title: 'Value', dataIndex: 'valueCode' },
  { title: 'Time Unit', dataIndex: 'timeUnit' },
  { title: 'Calculation Unit', dataIndex: 'calculationUnit' },
  { title: 'Status', dataIndex: 'status', width: 120 },
];

const refTableStyle = { maxWidth: '1600px' };

export const referenceTabItems = [
  { key: 'application-types', label: 'Application Types',
    children: (
      <Table query={useGetApplicationTypesQuery} endpoint="" columns={codeDescriptionColumns}
        rowKey="code" pageSize={10} style={refTableStyle}
        filterOptions={{ keys: ['code', 'description'], placeholder: 'Filter by code or description' }} />
    ) },
  { key: 'authorization-types', label: 'Authorization Types',
    children: (
      <Table query={useGetAuthorizationTypesQuery} endpoint="" columns={codeDescriptionColumns}
        rowKey="code" pageSize={10} style={refTableStyle}
        filterOptions={{ keys: ['code', 'description'], placeholder: 'Filter by code or description' }} />
    ) },
  { key: 'food-domains', label: 'Food Domains',
    children: (
      <Table query={useGetFoodDomainsQuery} endpoint="" columns={codeDescriptionColumns}
        rowKey="code" pageSize={10} style={refTableStyle}
        filterOptions={{ keys: ['code', 'description'], placeholder: 'Filter by code or description' }} />
    ) },
  { key: 'risk-assessment-deadlines', label: 'Risk Assessment Deadlines',
    children: (
      <Table query={useGetRiskAssessmentDeadlineCodesQuery} endpoint="" columns={riskDeadlineColumns}
        rowKey="id" pageSize={10} style={refTableStyle}
        filterOptions={{ keys: ['deadlineCode', 'typeCode'], placeholder: 'Filter by deadline or type code' }} />
    ) },
  { key: 'validation-deadlines', label: 'Validation Deadlines',
    children: (
      <Table query={useGetValidationDeadlineCodesQuery} endpoint="" columns={validationDeadlineColumns}
        rowKey="id" pageSize={10} style={refTableStyle}
        filterOptions={{ keys: ['deadlineCode'], placeholder: 'Filter by deadline code' }} />
    ) },
];